import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const LandingPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Simulate loader animation
        setTimeout(() => {
            const loader = document.getElementById("loader");
            if (loader) loader.classList.add("hidden");

            const headerAmbulance = document.querySelector(".ambulance");
            if (headerAmbulance) {
                headerAmbulance.style.display = "block";
                headerAmbulance.classList.add("entering");
            }
        }, 3500);

        // Create plus signs in the hero section
        const heroSection = document.querySelector(".hero");
        const plusContainer = document.createElement("div");
        plusContainer.classList.add("plus-container");
        heroSection.appendChild(plusContainer);

        const createPlus = () => {
            const plus = document.createElement("div");
            plus.classList.add("plus");
            plus.innerHTML = "+";
            plus.style.left = `${Math.random() * 100}%`;
            plus.style.top = `${Math.random() * 100}%`;
            plus.style.fontSize = `${Math.random() * 20 + 10}px`;
            plus.style.animationDuration = `${Math.random() * 3 + 3}s`;

            plusContainer.appendChild(plus);

            setTimeout(() => plus.remove(), 5000);
        };

        const interval = setInterval(createPlus, 700);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="landing-page">
            {/* Loader */}
            <div className="loader" id="loader">
                <div className="loader-container">
                    <img src="/ambulancesp.jpg" alt="Loading Ambulance" className="loader-ambulance" />
                </div>
            </div>

            {/* Header */}
            <header className="header">
                <div className="logo-container" onClick={() => window.location.reload()}>
                    <img src="/logo.jpg" alt="MediLocate+ Logo" className="logo" />
                    <h1 className="site-name">MediLocate+</h1>
                </div>
            </header>

            {/* Ambulance Animation */}
            <div className="ambulance-container">
  <img src="/ambulancesp.jpg" alt="Ambulance" className="ambulance" />
</div>


            {/* Hero Section */}
            <div className="hero">
                <h1>Find The Nearest Hospital Instantly</h1>
                <p>Search for hospitals near you based on your needs.</p>
                <div className="buttons">
                    <button className="emergency" onClick={() => navigate("/emergency")}>🚑 Emergency</button>
                    <button className="non-emergency" onClick={() => navigate("/non-emergency")}>👨‍⚕ Non-Emergency</button>
                </div>
            </div>

            {/* Cards Section */}
         <div className="landing-cards">
  <div
    className="landing-card"
    style={{ backgroundImage: "url('/bg1.png')" }}
  >
    <h3>Our Mission</h3>
    <p>
      We strive to provide quick and reliable hospital location services for
      all medical needs.
    </p>
  </div>

  <div
    className="landing-card"
    style={{ backgroundImage: "url('/bg2.png')" }}
  >
    <h3>Why Choose Us?</h3>
    <p>
      Accurate data, real-time updates, and user-friendly interface to assist
      you in emergencies.
    </p>
  </div>

  <div
    className="landing-card"
    style={{ backgroundImage: "url('/bg3.png')" }}
  >
    <h3>How It Works</h3>
    <p>
      Enter your location, choose the type of service, and get a list of the
      nearest hospitals instantly.
    </p>
  </div>
</div>


            {/* Footer Section */}
            <footer className="footer">
                <h3>National Helpline Numbers:</h3>
                <ul className="helpline-list">
                    <li>🚑 Ambulance: <strong>108</strong></li>
                    <li>🔥 Fire: <strong>101</strong></li>
                    <li>👮 Police: <strong>100</strong></li>
                    <li>📞 General Helpline: <strong>112</strong></li>
                </ul>
                <p className="disclaimer">⚠ Disclaimer: This service provides hospital location assistance and does not replace professional medical advice.</p>
            </footer>
        </div>
    );
};

export default LandingPage;